import { render, staticRenderFns } from "./Medium.vue?vue&type=template&id=20dcd386&scoped=true"
import script from "./Medium.vue?vue&type=script&lang=js"
export * from "./Medium.vue?vue&type=script&lang=js"
import style0 from "./Medium.vue?vue&type=style&index=0&id=20dcd386&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20dcd386",
  null
  
)

export default component.exports